import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Check, X } from 'lucide-react';
import { evaluatePassword } from '../utils/passwordPolicy';

// Şifre formlarının canlı kural listesi (belirle / değiştir / süresi dolanı yenile). Politika
// kiracının Şirket Ayarları'ndan gelir; sunucu aynı kuralı kayıtta yeniden denetler.
// `tone="dark"`: giriş sayfalarının koyu kartı.
export default function PasswordPolicyChecklist({ password, policy, tone = 'light' }) {
  const { t } = useTranslation();
  const rules = evaluatePassword(password, policy);

  return (
    <List $tone={tone} aria-label={t('passwordPolicy.title')}>
      {rules.map((rule) => (
        <Item key={rule.key} $ok={rule.ok} $tone={tone} data-rule={rule.key} data-ok={rule.ok ? 'true' : 'false'}>
          {rule.ok ? <Check size={14} aria-hidden="true" /> : <X size={14} aria-hidden="true" />}
          <span>{t(`passwordPolicy.rules.${rule.key}`, rule.params)}</span>
        </Item>
      ))}
    </List>
  );
}

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-family: ${({ theme }) => theme.metrics.font.family};
  font-size: 12px;
`;

const Item = styled.li`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${({ $ok, $tone, theme }) => {
    if ($ok) return theme.colors.auxiliar.success;
    return $tone === 'dark' ? 'rgba(255, 255, 255, 0.55)' : '#6B7280';
  }};
`;
